var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-7 px-5 d-flex justify-start align-center rounded-lg",attrs:{"flat":""}},[_c('div',[_c('v-img',{attrs:{"eager":"","width":"80","height":"80","src":_vm.src}})],1),_c('div',{staticClass:"text-h6 mx-5 grey--text text--darken-2"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }